import React from "react";
import Story from "./story";
/* global I18n */

class FolderStory extends Story {
  constructor (props) {
    super(props);
    this.state = {
      entity: props.story.entity,
      payload: props.story.payload
    };
  }

  render () {
    const user = this.state.entity;
    const username = user.name;
    const { title = "", url = "" } = this.state.payload;

    if (!title || !url || !username) { return null; }

    const caption = this.captionWithEntity(I18n.t("jslibrary.stream.user_created_folder",
      { user: username, folder: title, url }), user);

    return (
      <div
        className="afd-story"
        data-insights-category="myad-feed"
        data-insights-label="folder-story"
        data-insights-value={url}
      >
        <div className="afd-story__caption">{caption}</div>
      </div>
    );
  }
}

export default FolderStory;
